import type { Module } from 'vuex';
import { LanguageEntity } from '@/types/LanguageEntity';
import {RootState} from "@/store";

export interface LanguageEntityState {
  languageEntity: LanguageEntity | null;
  deleted: boolean;
}

const languageEntityModule: Module<LanguageEntityState, RootState> = {
  namespaced: true,
  state: (): LanguageEntityState => ({
    languageEntity: null,
    deleted: false,
  }),
  mutations: {
    setLanguageEntity(state, payload: any) {
      if (payload === null) {
        state.languageEntity = null;
        state.deleted = false;
        return;
      }
      state.languageEntity = LanguageEntity.fromRaw(payload);
      state.deleted = false;
    },
    setLanguageEntityUpdate(state, payload: any) {
      if (!state.languageEntity || state.languageEntity.idLanguageEntity !== payload.idLanguageEntity) return;
      if (payload.name !== undefined) state.languageEntity.name = payload.name;
      if (payload.orphan !== undefined) state.languageEntity.orphan = payload.orphan;
    },
    setLanguageEntityDelete(state, payload: { idLanguageEntity: number }) {
      if (state.languageEntity?.idLanguageEntity === payload.idLanguageEntity) {
        state.deleted = true;
      }
    },
    clearLanguageEntity(state) {
      state.languageEntity = null;
      state.deleted = false;
    },
  },
  actions: {
    wsSetLanguageEntity({ commit }, payload) {
      commit('setLanguageEntity', payload);
    },
    wsSetEmptyLanguageEntity({ commit }) {
      commit('setLanguageEntity', null);
    },
    wsLanguageEntityUpdate({ commit }, payload) {
      commit('setLanguageEntityUpdate', payload);
    },
    wsLanguageEntityDelete({ commit }, payload) {
      commit('setLanguageEntityDelete', payload);
    },
    clearLanguageEntity({ commit }) {
      commit('clearLanguageEntity');
    },
  },
};

export default languageEntityModule;
